import { Dialog, DialogSize, DialogTheme } from './dialog';
import { timingSafeEqual } from 'crypto';

const template = require('./view/dialog.handlebars');

export class DialogUI {
    protected obj: Dialog;
    protected el: JQuery;
    
    protected title: string;
    protected text: string;
    protected html: string;
    protected size: DialogSize;
    protected hideButtons: boolean;
    protected centered: boolean;
    protected confirmButtonText: string = 'Ok';
    protected cancelButtonText: string = 'Cancel';
    protected theme: DialogTheme = DialogTheme.default;
    
    protected hasIcon: boolean | string = false;
    
    public constructor(obj: Dialog) {
        this.obj = obj;
    }
    
    public setTitle(title: string) {
        this.title = title;
        if (this.el !== undefined) {
            this.el.find('.confirm__title').text(title);
        }
    }
    
    public setIcon(iconName?: string) {
        if (iconName) {
            this.hasIcon = iconName;
        } else {
            this.hasIcon = true;
        }
    }
    
    public setText(text: string) {
        this.text = text;
        if (this.el !== undefined) {
            this.el.find('.confirm__text').html(text);
        }
    }
    
    public setHTML(html: string) {
        this.html = html;
    }
    
    public setSize(size: DialogSize) {
        this.size = size;
    }
    
    public setConfirmButtonText(text: string) {
        this.confirmButtonText = text;
        if (this.el !== undefined) {
            this.el.find('[data-cancel]').text(text);
        }
    }
    
    public setCancelButtonText(text: string) {
        this.cancelButtonText = text;
        if (this.el !== undefined) {
            this.el.find('[data-confirm]').text(text);
        }
    }
    
    public setHideButtons() {
        this.hideButtons = true;
    }
    
    
    public setCenter() {
        this.centered = true;
    }
    
    public setTheme(theme: DialogTheme) {
        this.theme = theme;
    }
    
    public create() {
        let size = 'size-default';
        switch (this.size) {
            case DialogSize.small:
                size = 'size-small';
                break;
            case DialogSize.large:
                size = 'size-large';
                break;
            default:
                size = 'size-default';
        }
        
        this.el = $(template({
            title: this.title,
            text: this.text,
            html: this.html,
            size: size,
            hideButtons: this.hideButtons,
            centered: this.centered,
            hasIcon: this.hasIcon,
            confirmButtonText: this.confirmButtonText,
            cancelButtonText: this.cancelButtonText,
            theme: this.theme
        }));
    }
    
    public render() {
        this.create();
        $('body').append(this.el);
    }
    
    public update() {
        if (this.el !== undefined) {
            this.create();
        }
    }
    
    public bind(handleConfirm: () => void, handleCancel: () => void) {
        this.el.find('[data-confirm]').on('click', () => handleConfirm());
        this.el.find('[data-cancel]').on('click', () => handleCancel());
    }
    
    public destroy() {
        this.el.remove();
    }
}
